import { UPDATE_MENU } from "../config";
import { patch } from "./apiHelper";

export const updateMenu = (menuData) => patch(UPDATE_MENU, menuData);
